

import DATA from "../data/_entity.json";

const Values = () => {
   return (
      <>

         <h2>&nbsp;Our Values</h2>
         {Object.entries(DATA.entity.values).map((key) => {
            return (
               <div className="framer" key={key[0]}>
                  <h3>{key[0]}</h3>
                  <blockquote >
                     <span>
                        <i>{key[1]}</i>
                     </span>
                  </blockquote>
               </div>
            );
         })}

      </>
   )
}

export default Values;